
import { useState, useEffect } from 'react';
import { useUserStorage } from '@/hooks/campaign/utils/storageUtils';

export const useCampaignDetails = (amount: number) => {
  const [campaignId, setCampaignId] = useState<string>('');
  const [companyDetails, setCompanyDetails] = useState<any>({});
  const [devices, setDevices] = useState<number>(0);
  const [duration, setDuration] = useState<number>(7);
  const { getItem } = useUserStorage();

  useEffect(() => {
    // Generate or get existing campaign ID
    let existingCampaignId = localStorage.getItem('currentCampaignId');
    
    if (!existingCampaignId) {
      // Generate a new campaign ID
      existingCampaignId = `campaign-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
      localStorage.setItem('currentCampaignId', existingCampaignId);
      console.log('Generated new campaign ID:', existingCampaignId);
    }
    
    setCampaignId(existingCampaignId);

    // Get company details from localStorage
    const formData = getItem('formData');
    if (formData) {
      try {
        const parsedFormData = JSON.parse(formData);
        setCompanyDetails(parsedFormData);
      } catch (e) {
        console.error('Error parsing form data:', e);
      }
    }

    // Get devices count
    const devicesCount = Number(getItem('devices')) || 0;
    setDevices(devicesCount);

    // Get duration
    const campaignDuration = Number(getItem('duration')) || 7;
    setDuration(campaignDuration);
  }, [getItem]);

  return {
    campaignId,
    companyDetails,
    devices,
    duration
  };
};
